import { graphql } from '@/generated/gql';

export const CONTRACT_DEMAND_AWARDING_QUERY = graphql(/* GraphQL */ `
  query ContractDemandAwarding($id: UUID!) {
    tesseract {
      contractDemand(id: $id) {
        id
        status
        sequenceNumber
        createdAt
        updatedAt
        deletedAt
        priority
        responsibleUserId
        tagIds
        bestOfferQuoteItems {
          id
        }
        sourcingCases {
          id
          status
          createdAt
          updatedAt
          sequenceNumber
          isAwardable
          supplier {
            id
            supplierId
            name
            contact {
              id
              internalId
              email
              firstName
              lastName
              language
            }
          }
          sourceReferences {
            id
            sourceReference
            url
          }
          quote {
            id
            createdAt
            totalValue
            discount
            totalDiscountedValue
            totalPriceDiscount
            currency
            validFrom
            validTo
            lineItems {
              id
              demandRequestItemId
              title
              quantity
              totalValue
              totalDiscountedValue
              pricePerUnit
              pricePerPriceUnit
              discountedPricePerUnit
              discountedPricePerPriceUnit
              status
              bidDeclinedReason
              bidDeclinedReasonText
              negotiationFailedReason
              negotiationFailedReasonText
              isAwardable
            }
          }
          issues {
            id
            variant
            status
          }
        }
        competitiveBiddingRule {
          id
          variant
          biddingPeriodDays
          deadline
          deadlineExceeded
        }
        demandRequest {
          id
          createdAt
          requestedAt
          validityPeriod {
            from
            to
          }
          summary
          totalValue
          currency
          commodityGroupId
          incoTermsId
          paymentTermsId
          lineItems {
            id
            createdAt
            title
            description
            quantity
            minimumOrderQuantity
            baselinePricePerUnit
            baselinePricePerPriceUnit
            unitId
            priceUnit
            deliveryLocationId
            organizationId
            commodityId
            commodityGroupId
            totalValue
          }
        }
      }
    }
  }
`);
